var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.253 2.478c2.06-.859 4.128 1.209 3.269 3.27l-5.923 14.216c-1.159 2.78-5.234 2.31-5.729-.661l-.739-4.434-4.434-.74c-2.971-.494-3.44-4.569-.66-5.727l14.216-5.924Zm1.423 2.5a.5.5 0 0 0-.654-.654L4.806 10.248c-.927.386-.77 1.744.22 1.91l4.434.738a2 2 0 0 1 1.644 1.644l.739 4.434c.165.99 1.523 1.147 1.91.22l5.923-14.216Z",
    fill: "#777E91"
  })));
};
export default SvgLine;